export const MerchantListMessages = {
  loadMoreButton: {
    id: 'Pages.MerchantSelection.MerchantList.loadMoreButton',
    description: 'Select merchant page load more button',
  },
}
